import { useCallback as useReactCallback } from 'react'

export const useCallback = useReactCallback

export default useCallback
